import React, { useState, useEffect } from 'react';
import Bubble from "../Bubble/Bubble";
import './MegaDrivers.styles.scss';
import { Link } from "react-router-dom";
import TotalValue from "../TotalValue/TotalValue";

function MegaDrivers({ data }) {
    const [maxValue, setMaxValue] = useState(0.0001);

    useEffect(() => {
        let max = 0.0001;
        const checkMax = (item) => {
            const { value, total } = item;
            const values = [value, total];
            max = Math.max(max, ...values);
        };
        if (data) {
            data.forEach(checkMax);
        } else {
            data.forEach(checkMax);
        }
        setMaxValue(max);
    }, [data]);
    return (
        <div className="mega-drivers">
            {data.map((driver, inx) => (
                <div key={inx} className="mega-driver">
                    {driver.link ? (
                        <Link
                            to={driver.link}
                            className="mega-driver__name"
                        >
                            {driver.name}
                        </Link>
                    ) : (
                        <div className="mega-driver__name">
                            {driver.name}
                        </div>
                    )}
                    <div className="mega-driver__bubble">
                        <Bubble value={(driver.value / maxValue) * 100}/>
                        <div className="mega-driver__value">{driver.value}%</div>
                        {/*<div
                            className="mega-driver__total"
                            style={{ height: `${(driver.total / maxValue) * 100}%` }}
                        >
                            <TotalValue className="mega-driver__total-value">
                                {driver.total}%
                            </TotalValue>
                        </div>*/}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default MegaDrivers;